module.exports = __webpack_public_path__ + "img/lico.17fd274d.png";